import { useMediaQuery } from '@mui/material';
import { useIsEmbedded } from './useIsEmbedded';

/**
 * check app ran in standalone mode
 */
export const useIsStandalone = (): boolean => {
  const isEmbedded = useIsEmbedded();

  return useMediaQuery('(display-mode: standalone)') || Boolean(isEmbedded);
};
